module.exports = __webpack_public_path__ + "img/tomate.f42c37b7.jpg";